import type { SVGProps } from 'react';

/**
 * Caladan silhouette — main planet plus two moons.
 * Rendered as currentColor fills so it inherits the parent text color
 * (theme accent) exactly the way the Lucide Zap icon did before.
 */
export function CaladanLogo({ size = 20, ...rest }: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Caladan Capital"
      {...rest}
    >
      {/* Main planet — Caladan */}
      <circle cx="12" cy="13" r="7" fill="currentColor" />
      {/* Upper-right moon */}
      <circle cx="20" cy="7" r="2" fill="currentColor" />
      {/* Lower-left moon */}
      <circle cx="6" cy="20" r="1.6" fill="currentColor" />
    </svg>
  );
}
